import React from 'react';
import Icon from '../../../components/AppIcon';

const Legend = ({ stablecoinPercentage, m2Percentage }) => {
  const legendItems = [
    {
      id: 'stablecoin',
      label: 'Stablecoins',
      color: 'bg-[#D08A2A]',
      percentage: stablecoinPercentage,
      icon: 'Coins',
      description: 'Total market capitalization of major stablecoins'
    },
    {
      id: 'm2',
      label: 'M2 Money Supply',
      color: 'bg-[#D9D9D9]',
      percentage: m2Percentage,
      icon: 'Landmark',
      description: 'The remaining of traditional money supply including cash, checking deposits, and savings'
    }
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-sm border border-border">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Info" size={20} color="var(--color-primary)" />
        <h2 className="text-base md:text-lg font-semibold text-foreground">
          Data Legend
        </h2>
      </div>
      <div className="space-y-3">
        {legendItems?.map((item) => (
          <div 
            key={item?.id}
            className="flex items-start gap-3 p-3 rounded-lg transition-colors duration-300 hover:bg-muted"
          >
            <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded flex-shrink-0 rounded-br-sm rounded-t-sm rounded-bl-sm">
              <div className={`w-8 h-8 md:w-10 md:h-10 ${item?.color} rounded rounded-br-sm rounded-t-sm rounded-bl-sm`} />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="text-sm md:text-base font-medium text-foreground">
                  {item?.label}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
        </div>
      </div>
    </div>
  );
};

export default Legend;